import * as Yup from 'yup';

import { globalMessages } from '../../../../helpers';

export const schema = Yup.object().shape({
  rejectOption: Yup.object().required(globalMessages.form.required),
  rejectComment: Yup.string().nullable(),
});
